import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "chartContainer" }
const _hoisted_2 = {
  key: 0,
  class: "loading-pie"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_content_loader, { height: "250" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.isMounted)
      ? (_openBlock(), _createBlock(_component_apexchart, {
          key: 1,
          height: _ctx.height,
          options: _ctx.computedChartOptions,
          series: _ctx.series,
          width: _ctx.width,
          onDataPointSelection: _ctx.onPieChartClick
        }, null, 8, ["height", "options", "series", "width", "onDataPointSelection"]))
      : _createCommentVNode("", true)
  ]))
}